angular.module('app.directives').directive('firmwareVersion', () =>
    ({
        restrict: 'E',
        scope: {
            boxcaster: '=',
            concise: '=',
            float: '='
        },
        template: `
          <span ng-if="showVersion">
            {{boxcaster.firmware_released_at | date:'shortDate'}}
          </span>
          <span ng-if="!showVersion">
            (N/A)
          </span>
          <span ng-if="!concise">
            &nbsp;&nbsp;
            v{{ boxcaster.firmware_revision }}
            &nbsp;&nbsp;
          </span>
          <span ng-switch="boxcaster.firmware_status" ng-class="{'pull-right': float}">
            <span ng-switch-when="current" class="text-success">
              <i class="fa fa-check"></i>
            </span>
            <span ng-switch-when="outdated" class="text-warning">
              <i class="fa fa-warning"></i>
              <span ng-if="!concise">Outdated</span>
            </span>
            <span ng-switch-when="invalid" class="text-danger">
              <i class="fa fa-warning"></i>
              <span ng-if="!concise">Invalid</span>
            </span>
          </span>
          `,
        link(scope, element, attr) {
            return scope.$watch(
                () => scope.boxcaster.firmware_released_at,
                d => scope.showVersion = d && !d.startsWith('1970'));
        }
    }));


// WEBPACK FOOTER //
// ./directives/firmware_version.js